import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router'
import { StoresContext } from '@App/contexts'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import WorkMergeRequestListStore from '@App/stores/rightsholder/workMerge/work-merge-request-list-store'
import WorkMergeRequestCard from '@Scenes/RightsholderScene/WorkMerge/WorkMergeRequestCard'
import './index.scss'

interface WorkMergeRequestListProps {
    store: WorkMergeRequestListStore
    dateLabel: string
    requestPath: (rightsholderId: number, requestId: number) => string
    title: string
    description: string
}

const WorkMergeRequestList = (props: WorkMergeRequestListProps) => {
    const { store, dateLabel, requestPath, title, description } = props
    const { rightsholderStore } = useContext(StoresContext)
    const navigate = useNavigate()

    useEffect(() => {
        store.loadRequests()
    }, [store])

    if (store.isLoading) {
        return <PointPreloader />
    }

    if (store.requests.length === 0) {
        return (
            <div className="work-merge-request-list-empty">
                <p className="work-merge-request-list-empty-title">{title}</p>
                <p className="work-merge-request-list-empty-description">{description}</p>
            </div>
        )
    }

    return (
        <div className="work-merge-request-list">
            {store.requests.map((request) => (
                <WorkMergeRequestCard
                    key={request.id}
                    request={request}
                    dateLabel={dateLabel}
                    onViewRequest={() => navigate(requestPath(rightsholderStore.currentRightsholderId, request.id))}
                />
            ))}
        </div>
    )
}

export default observer(WorkMergeRequestList)
